/**
 * Map free-text / enum income strings onto INCOME_LEVELS indexes.
 *
 * Exact match first, then longest-first substring match so that
 * "medium-low" does not hit "low" and "medium-high" does not hit "medium".
 */
export function resolveIncomeLevelIndex(
  value,
  levels = ['low', 'medium-low', 'medium', 'medium-high', 'high'],
) {
  const text = String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
  if (!text) return null;

  const exactIndex = levels.findIndex((level) => text === level);
  if (exactIndex >= 0) return exactIndex;

  const longestFirst = [...levels].sort((a, b) => b.length - a.length);
  for (const level of longestFirst) {
    if (text.includes(level)) {
      return levels.indexOf(level);
    }
  }

  return null;
}
